import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { quizActions } from '../actions/quizes.actions';
import { selectQuiz, selectQuizId, selectLoaded, selectLoading } from '../selectors/quizes.selectors';

@Injectable({
    providedIn: 'root',
})
export class QuizFacade {
    private readonly store = inject(Store);

    // Observable selectors
    readonly quizId$ = this.store.select(selectQuizId);
    readonly quiz$ = this.store.select(selectQuiz);
    readonly quizNonNullable$ = this.quiz$.pipe(filter((quiz) => quiz !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly loaded$ = this.store.select(selectLoaded);

    // Signal selectors
    readonly quizId = this.store.selectSignal(selectQuizId);
    readonly quiz = this.store.selectSignal(selectQuiz);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly loaded = this.store.selectSignal(selectLoaded);

    // Actions
    getQuiz(id: string): void {
        this.store.dispatch(quizActions.getQuiz({ id }));
    }

    clear(): void {
        this.store.dispatch(quizActions.clear());
    }
}
